import React, { Component } from 'react'
import gql from 'graphql-tag'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormHelperText from '@material-ui/core/FormHelperText'
import Select from '@material-ui/core/Select'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import getLoginId from '../../../utils/getLoginId'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import {
  InputLabel,
  RadioGroup,
  Radio,
  FormControlLabel
} from '@material-ui/core'
import { Query, withApollo } from 'react-apollo'
import './AddPartner.css'
import Countries from '../Countries'
import States from '../States'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import PropTypes from 'prop-types'
import ConfirmationalDialog from '../../common/ConfirmationDialog'

const GET_STATES_FOR_COUNTRY = gql`
  query getStatesByCountryId($countryId: Int!) {
    allStatesByCountryId(country_id: $countryId) {
      name
      zone_id
    }
  }
`

// username validation
const GET_USERNAME = gql`
  query checkUsername($username: String!) {
    checkUsername(username: $username)
  }
`

// Business name validation
const GET_BUSINESSNAME = gql`
  query($businessname: String!) {
    checkBusinessName(businessName: $businessname)
  }
`

// Business name validation
const GET_CONTACTNO = gql`
  query checkPartnerContactNumber($phoneno: String!) {
    checkPartnerContactNumber(contactNumber: $phoneno)
  }
`

// Business email validation
const GET_EMAIL = gql`
  query checkPartnerEmail($email: String!) {
    checkPartnerEmail(email: $email)
  }
`

// Business pan validation
const GET_PAN_NUMBER = gql`
  query checkPartnerPanNumber($pan: String!) {
    checkPartnerPanNumber(panNumber: $pan)
  }
`

// calling server for updation
const ADD_PARTNER = gql`
  mutation partnerSignup(
    $username: String!
    $password: String!
    $accountType: String!
    $businessName: String!
    $email: String!
    $contactPerson: String!
    $contactNumber: String!
    $billingMode: Int!
    $address: String!
    $city: String!
    $state: Int!
    $country: Int!
    $pincode: Int!
    $panNumber: String!
    $partnerType: String!
    $typeOfPartner: ClientPartnerType!
    $salesPersonId: Int!
    $solution: Solution!
  ) {
    partnerSignup(
      username: $username
      password: $password
      accountType: $accountType
      businessName: $businessName
      email: $email
      contactPerson: $contactPerson
      contactNumber: $contactNumber
      billingMode: $billingMode
      address: $address
      city: $city
      state: $state
      country: $country
      pincode: $pincode
      panNumber: $panNumber
      partnerType: $partnerType
      typeOfPartner: $typeOfPartner
      salesPersonId: $salesPersonId
      solution: $solution
    )
  }
`
const GET_ALL_SALESPERSON = gql`
  query getAllSalesPerson($partnerLoginId: Int) {
    getAllSalesPerson(partnerLoginId: $partnerLoginId) {
      id
      name
    }
  }
`
const BILLING_MODES = [
  {
    value: 1,
    label: 'PREPAID'
  },
  {
    value: 2,
    label: 'POSTPAID'
  }
]

class AddPartner extends Component {
  state = {
    businessname: '',
    country: '',
    email: '',
    phoneno: '',
    contactp: '',
    address: '',
    city: '',
    state: '',
    pin: '',
    pan: '',
    clttype: '',
    username: '',
    isEmailValid: true,
    isBusinessNameValid: true,
    isPhonenoValid: true,
    isContactpValid: true,
    isAddressValid: true,
    isCityValid: true,
    isCountryValid: true,
    isStateValid: true,
    isPinValid: true,
    isPanValid: true,
    isUsernameValid: true,
    isCltTypeValid: true,
    isCancelConfDialogOpen: false,
    isSaveConfDialogOpen: false,
    getCountryId: '',
    getStatesId: [],
    password: 'Tracking123',
    isUsernameAvailable: '',
    typeOfPartner: 'REAL',
    billingMode: '',
    allSalesPerson: [],
    salesPerson: '',
    domainName: '',
    panNoRes: '',
    phoneNoRes: '',
    nameRes: '',
    emailRes: '',
    userNameRes: '',
    allSolution: [
      {
        value: 'API',
        label: 'API'
      },
      {
        value: 'PORTAL',
        label: 'PORTAL'
      }
    ],
    solution: ''
  }

  handleSaveClick = e => {
    this.setState({ isSaveConfDialogOpen: true })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleSaveNegativeResponse = e => {
    this.setState({ isSaveConfDialogOpen: false })
  }
  cancelForm = e => {
    this.props.history.goBack()
  }
  handleCancelClick = e => {
    this.setState({ isCancelConfDialogOpen: true })
  }

  handleInputChange = name => e => this.setState({ [name]: e.target.value })

  handleChange = async event => {
    // console.log(event.target.value)
    this.setState({ country: event.target.value })
    const { data } = await this.props.client.query({
      query: GET_STATES_FOR_COUNTRY,
      variables: { countryId: event.target.value }
    })
    await this.onCountryFetched(data.allStatesByCountryId)
  }
  handleStateRender() {
    if (this.state.country) {
      return (
        <Grid item xs={6}>
          <FormGroup className="form-input">
            <States
              countryId={this.state.country}
              zoneId={this.state.state}
              handleStateChange={this.handleStateChange}
            />
          </FormGroup>
        </Grid>
      )
    }
  }
  handleStateChange = state => {
    this.setState({ state: state.value }, () =>
      console.log('state', this.state.state)
    )
  }
  handleCountryChange = country => {
    // console.log('counter', country)
    if (!country) {
      this.setState({ state: '', country: '' })
    } else {
      this.setState({ state: '', country: country.value })
    }
  }

  handleChangeState = event => this.setState({ state: event.target.value })

  handleChangeclt = event => this.setState({ clttype: event.target.value })

  checkBusinessNameValidity = async event => {
    console.log('gggg')
    const regex = new RegExp(
      /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{5,32}$/
    )
    const { data } = await this.props.client.query({
      query: GET_BUSINESSNAME,
      variables: { businessname: this.state.businessname }
    })

    this.setState({
      isBusinessNameValid:
        regex.test(this.state.businessname) &&
        this.state.businessname !== '' &&
        data.checkBusinessName === 'AVAILABLE'
    })
    if (regex.test(this.state.businessname) === false) {
      this.setState({ nameRes: 'Invalid Business Name' })
    } else if (data.checkBusinessName !== 'AVAILABLE') {
      this.setState({ nameRes: 'Business name already exist' })
    }
  }

  checkEmailValidity = async event => {
    const regex = new RegExp(
      // eslint-disable-next-line
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )

    const { data } = await this.props.client.query({
      query: GET_EMAIL,
      variables: { email: this.state.email }
    })

    this.setState({
      isEmailValid:
        regex.test(this.state.email) &&
        this.state.email !== '' &&
        data.checkPartnerEmail === 'AVAILABLE'
    })
    if (regex.test(this.state.email) === false) {
      this.setState({ emailRes: 'Invalid email id' })
    } else if (data.checkPartnerEmail !== 'AVAILABLE') {
      this.setState({ emailRes: 'Email already exist' })
    }
  }

  checkPhonenoValidity = async event => {
    // const regex = new RegExp(
    //   // eslint-disable-next-line
    //   /^(\+91[-\s]?)?[0]?(91)?[789]\d{9}$/
    // )
    console.log('hgfjagf')
    const regex = new RegExp(/^(\+91[-\s]?)?[0]?(91)?[1-9]\d{9,10}$/)
    const { data } = await this.props.client.query({
      query: GET_CONTACTNO,
      variables: { phoneno: this.state.phoneno }
    })

    this.setState({
      isPhonenoValid:
        regex.test(this.state.phoneno) &&
        this.state.phoneno !== '' &&
        data.checkPartnerContactNumber === 'AVAILABLE'
    })
    if (regex.test(this.state.phoneno) === false) {
      this.setState({ phoneNoRes: 'Invalid phone number' })
    } else if (data.checkPartnerContactNumber !== 'AVAILABLE') {
      this.setState({ phoneNoRes: 'Phone number already exist' })
    }
  }

  checkContactpValidity = () => {
    const regex = new RegExp(/^[a-zA-Z\s]{5,32}$/)
    this.setState({
      isContactpValid:
        regex.test(this.state.contactp) || this.state.contactp === ''
    })
  }

  checkAddressValidity = () => {
    const regex = new RegExp(/^[a-zA-Z0-9\s,.'-]{3,300}$/)
    this.setState({
      isAddressValid:
        regex.test(this.state.address) || this.state.address !== ''
    })
  }

  checkCityValidity = () => {
    const regex = new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/)
    this.setState({
      isCityValid:
        regex.test(this.state.city) &&
        this.state.city !== '' &&
        parseInt(this.state.city.length, 10) < 16
    })
  }

  checkPinValidity = () => {
    const regex = new RegExp(/^[1-9][0-9]{5}$/)
    this.setState({
      isPinValid: regex.test(this.state.pin) || this.state.pin !== ''
    })
  }

  checkPanValidity = async event => {
    const regex = new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)
    this.setState({ panNoRes: '' })
    const { data } = await this.props.client.query({
      query: GET_PAN_NUMBER,
      variables: { pan: this.state.pan }
    })

    this.setState({
      isPanValid:
        regex.test(this.state.pan) &&
        this.state.pan !== '' &&
        data.checkPartnerPanNumber === 'AVAILABLE'
    })
    if (regex.test(this.state.pan) === false) {
      this.setState({ panNoRes: 'Invalid pan number' })
    } else if (data.checkClientPanNumber !== 'AVAILABLE') {
      this.setState({ panNoRes: 'Pan number already exist' })
    }
  }

  checkUsernameValidity = async event => {
    this.setState({ userNameRes: '' })
    // const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{3,30}$/)
    const regex = new RegExp(/^[a-zA-Z0-9.\-_$@*!]{5,32}$/)

    const { data } = await this.props.client.query({
      query: GET_USERNAME,
      variables: { username: this.state.username }
    })
    this.setState({
      isUsernameValid:
        regex.test(this.state.username) &&
        this.state.username !== '' &&
        data.checkUsername === 'AVAILABLE'
    })
    this.setState({
      isUsernameAvailable: data.checkUsername
    })
    if (regex.test(this.state.username) === false) {
      this.setState({ userNameRes: 'Invalid user name' })
    } else if (data.checkUsername !== 'AVAILABLE') {
      this.setState({ userNameRes: 'User name already exist' })
    }
    console.log('un', this.state.isUsernameValid)
    if (
      this.state.isUsernameValid &&
      this.state.isUsernameAvailable === 'AVAILABLE'
    ) {
      this.setState({
        inventoryUsername: this.state.username + '_INV',
        accountsUsername: this.state.username + '_ACC',
        serviceUsername: this.state.username + '_SER',
        salesUsername: this.state.username + '_SAL',
        inventoryPassword: this.state.username + '@INV',
        accountsPassword: this.state.username + '@ACC',
        servicePassword: this.state.username + '@SER',
        salesPassword: this.state.username + '@SAL'
      })
    } else {
      this.setState({
        inventoryUsername: '',
        accountsUsername: '',
        serviceUsername: '',
        salesUsername: '',
        inventoryPassword: '',
        accountsPassword: '',
        servicePassword: '',
        salesPassword: ''
      })
    }
  }

  checkCountryValidity = () => {
    this.setState({
      isCountryValid: this.state.country !== ''
    })
  }

  checkStateValidity = () => {
    this.setState({
      isStateValid: this.state.state !== ''
    })
  }

  checkCltTypeValidity = () => {
    this.setState({
      isCltTypeValid: this.state.clttype !== ''
    })
  }

  onCountryFetched = async getStatesId => this.setState({ getStatesId })

  hanldeBillingModeChange = event => {
    this.setState({ billingMode: event.target.value })
  }

  handleSalesPersonChange = event => {
    if (!event) {
      this.setState({ salesPerson: '' })
    } else {
      this.setState({ salesPerson: event.target.value })
    }
  }

  handleSolutionChange = event => {
    if (!event) {
      this.setState({ solution: '' })
    } else {
      this.setState({ solution: event.target.value })
    }
  }

  handleSubmit = async e => {
    e.preventDefault()

    const { data, errors } = await this.props.client.mutate({
      mutation: ADD_PARTNER,
      variables: {
        username: this.state.username,
        password: this.state.password,
        accountType: 'PA',
        businessName: this.state.businessname,
        email: this.state.email,
        contactPerson: this.state.contactp,
        contactNumber: this.state.phoneno,
        address: this.state.address,
        city: this.state.city,
        state: parseInt(this.state.state, 10),
        country: parseInt(this.state.country, 10),
        pincode: parseInt(this.state.pin, 10),
        panNumber: this.state.pan,
        partnerType: this.state.clttype,
        typeOfPartner: this.state.typeOfPartner,
        billingMode: this.state.billingMode,
        salesPersonId: this.state.salesPerson,
        solution: this.state.solution
      },
      refetchQueries: ['allPartnerDetails']
    })
    if (data.partnerSignup) {
      // console.log('registration successful')
      this.props.openSnackbar('Registered Successfully')
      this.props.history.push({
        pathname: '/home/users/partner'
      })
    } else {
      this.props.openSnackbar('Registartion Failed')
    }
    this.setState({
      username: '',
      businessname: '',
      contactNumber: '',
      email: '',
      contactPerson: '',
      address: '',
      city: '',
      state: '',
      country: '',
      pincode: '',
      panNumber: '',
      partnerType: '',
      billingMode: '',
      salesPerson: '',
      typeOfPartner: 'REAL',
      solution: ''
    })

    // if (data.partnerSignup && this.state.domainName !== '') {
    //   const { data: whiteLabel } = await this.props.client.mutate({
    //     mutation: ADD_DOMAIN_CONFIGURATION,
    //     variables: {
    //       domainName: this.state.domainName,
    //       header: {
    //         title: this.state.pageTitle,
    //         shortcutIcon: this.state.faviconLink
    //       },
    //       page: {
    //         logo: this.state.logo
    //       },
    //       customPage: false
    //     }
    //   })

    //   //   if (whiteLabel.addDomainConfiguration.domain) {
    //   //     this.props.openSnackbar('Registered Successfully')
    //   //   } else {
    //   //     this.props.openSnackbar(errors[0].message)
    //   //   }
    //   //   this.setState({
    //   //     username: '',
    //   //     businessname: '',
    //   //     contactNumber: '',
    //   //     email: '',
    //   //     contactPerson: '',
    //   //     address: '',
    //   //     city: '',
    //   //     state: '',
    //   //     country: '',
    //   //     pincode: '',
    //   //     panNumber: '',
    //   //     partnerType: '',
    //   //     billingMode: '',
    //   //     salesPerson: '',
    //   //     typeOfPartner: 'REAL'
    //   //   })
    //   // } else {
    //   // if (data.partnerSignup) {
    //   //   console.log('registration successful')
    //   //   this.props.openSnackbar('Registered Successfully')
    //   // } else {
    //   //   this.props.openSnackbar('Registartion Failed')
    //   // }
    //   // this.setState({
    //   //   username: '',
    //   //   businessname: '',
    //   //   contactNumber: '',
    //   //   email: '',
    //   //   contactPerson: '',
    //   //   address: '',
    //   //   city: '',
    //   //   state: '',
    //   //   country: '',
    //   //   pincode: '',
    //   //   panNumber: '',
    //   //   partnerType: '',
    //   //   billingMode: '',
    //   //   salesPerson: '',
    //   //   typeOfPartner: 'REAL'
    //   // })
    // }
  }

  getAllSalesPersonDetails = async () => {
    const fetchSalesPersonData = await this.props.client.query({
      query: GET_ALL_SALESPERSON,
      variables: {
        // partnerLoginId: getLoginId()
        partnerLoginId: 2
      }
    })
    const {
      data: { getAllSalesPerson }
    } = fetchSalesPersonData
    const salesPersonsDetails = getAllSalesPerson.map(salesPerson => ({
      value: salesPerson.id,
      label: salesPerson.name
    }))
    this.setState({ allSalesPerson: salesPersonsDetails }, () => {
      console.log('all sales person', this.state.allSalesPerson, getLoginId())
    })
  }
  componentDidMount = () => {
    this.getAllSalesPersonDetails()
  }
  render() {
    const { classes } = this.props
    return (
      <div className="Landing">
        <ConfirmationalDialog
          isDialogOpen={this.state.isSaveConfDialogOpen}
          dialogMessage={
            "Are you sure you want to Save this customer's details?"
          }
          negativeResponseHandler={this.handleSaveNegativeResponse}
          positiveResponseHandler={this.handleSubmit}
        />
        <ConfirmationalDialog
          isDialogOpen={this.state.isCancelConfDialogOpen}
          dialogMessage={
            'Are you sure you want to Cancel customer registration?'
          }
          negativeResponseHandler={this.handleCancelNegativeResponse}
          positiveResponseHandler={this.cancelForm}
        />
        <Grid
          container
          justify="center"
          className="full-screen"
          alignItems="flex-end"
        >
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Register Partner"
                subheader="All fields marked with (*) are mandatory"
                // subheaderTypographyProps={{
                //   className: classes.italicizedText
                // }}
              />

              <div className="formouter">
                <CardContent>
                  <Grid container spacing={16}>
                    <Grid item xs={12} md={6}>
                      <FormGroup className="form-input">
                        <TextField
                          id="businessname"
                          name="businessname"
                          className="textfield"
                          margin="dense"
                          label="Business Name"
                          value={this.state.businessname}
                          required
                          onChange={this.handleInputChange('businessname')}
                          error={!this.state.isBusinessNameValid}
                          onBlur={this.checkBusinessNameValidity}
                        />
                        <FormHelperText
                          id="name-error-text"
                          className="Error_msg"
                        >
                          {!this.state.isBusinessNameValid
                            ? this.state.nameRes
                            : ''}
                        </FormHelperText>
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <RadioGroup
                        aria-label="position"
                        name="position"
                        value={this.state.typeOfPartner}
                        onChange={this.handleInputChange('typeOfPartner')}
                        row
                      >
                        <FormControlLabel
                          value="REAL"
                          control={<Radio color="primary" />}
                          label="Billable"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value="DEMO"
                          control={<Radio color="primary" />}
                          label="Non-Billable"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl className="selectbox">
                        <InputLabel htmlFor="selectLabel">
                          Select Type
                        </InputLabel>

                        {/* <FormGroup className="form-input"> */}
                        <Select
                          value={this.state.clttype}
                          onChange={this.handleChangeclt}
                          name="Select Type"
                          error={!this.state.isCltTypeValid}
                          onBlur={this.checkCltTypeValidity}
                          input={<Input name="clttype" id="age-helper" />}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value={'Franchise'}>Franchisee</MenuItem>
                          <MenuItem value={'Assosciates'}>Associate</MenuItem>
                          <MenuItem value={'Channel Partner'}>
                            Channel Partner
                          </MenuItem>
                        </Select>
                        {/* </FormGroup> */}
                        <FormHelperText
                          id="name-error-text"
                          className="Error_msg"
                        >
                          {!this.state.isCltTypeValid
                            ? 'Invalid Selection'
                            : ''}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        <TextField
                          id="email"
                          name="email"
                          className="textfield"
                          margin="dense"
                          label="Primary Email"
                          type="email"
                          value={this.state.email}
                          required
                          onChange={this.handleInputChange('email')}
                          // placeholder="Email"
                          error={!this.state.isEmailValid}
                          onBlur={this.checkEmailValidity}
                        />
                        <FormHelperText
                          id="name-error-text"
                          className="Error_msg"
                        >
                          {!this.state.isEmailValid ? this.state.emailRes : ''}
                        </FormHelperText>
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        <TextField
                          id="phoneno"
                          name="phoneno"
                          className="textfield"
                          margin="dense"
                          label="Contact No"
                          type="text"
                          value={this.state.phoneno}
                          required
                          onChange={this.handleInputChange('phoneno')}
                          error={!this.state.isPhonenoValid}
                          onBlur={this.checkPhonenoValidity}
                        />
                        <FormHelperText
                          id="name-error-text"
                          className="Error_msg"
                        >
                          {!this.state.isPhonenoValid
                            ? this.state.phoneNoRes
                            : ''}
                        </FormHelperText>
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        <TextField
                          id="contactp"
                          name="contactp"
                          className="textfield"
                          margin="dense"
                          label="Contact Person"
                          type="text"
                          value={this.state.contactp}
                          required
                          onChange={this.handleInputChange('contactp')}
                          error={!this.state.isContactpValid}
                          onBlur={this.checkContactpValidity}
                        />
                        <FormHelperText
                          id="name-error-text"
                          className="Error_msg"
                        >
                          {!this.state.isContactpValid
                            ? 'Invalid Contact Person Name'
                            : ''}
                        </FormHelperText>
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        <TextField
                          id="address"
                          name="address"
                          className="textfield"
                          margin="dense"
                          label="Address"
                          type="Multi-line"
                          value={this.state.address}
                          required
                          onChange={this.handleInputChange('address')}
                          error={!this.state.isAddressValid}
                          onBlur={this.checkAddressValidity}
                        />
                        <FormHelperText
                          id="name-error-text"
                          className="Error_msg"
                        >
                          {!this.state.isAddressValid ? 'Invalid Address' : ''}
                        </FormHelperText>
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        <TextField
                          id="city"
                          name="city"
                          className="textfield"
                          margin="dense"
                          label="City"
                          // type="Multi-line"
                          value={this.state.city}
                          required
                          onChange={this.handleInputChange('city')}
                          error={!this.state.isCityValid}
                          onBlur={this.checkCityValidity}
                        />
                        <FormHelperText
                          id="name-error-text"
                          className="Error_msg"
                        >
                          {!this.state.isCityValid ? 'Invalid City' : ''}
                        </FormHelperText>
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        <Countries
                          countryId={this.state.country}
                          handleCountryChange={this.handleCountryChange}
                        />
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      {this.handleStateRender()}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        <TextField
                          id="pin"
                          name="pin"
                          className="textfield"
                          margin="dense"
                          label="Pin Code"
                          // type="Multi-line"
                          value={this.state.pin}
                          required
                          onChange={this.handleInputChange('pin')}
                          error={!this.state.isPinValid}
                          onBlur={this.checkPinValidity}
                        />
                        <FormHelperText
                          id="name-error-text"
                          className="Error_msg"
                        >
                          {!this.state.isPinValid ? 'Invalid Pin Number' : ''}
                        </FormHelperText>
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        <TextField
                          id="pan"
                          name="pan"
                          className="textfield"
                          margin="dense"
                          label="PAN No"
                          // type="Multi-line"
                          value={this.state.pan}
                          required
                          onChange={this.handleInputChange('pan')}
                          error={!this.state.isPanValid}
                          onBlur={this.checkPanValidity}
                        />
                        <FormHelperText
                          id="name-error-text"
                          className="Error_msg"
                        >
                          {this.state.isPanValid ? '' : this.state.panNoRes}
                        </FormHelperText>
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        {/* <div className="usernamediv" xs={12} sm={4}> */}
                        <TextField
                          id="username"
                          name="username"
                          className="textfield"
                          margin="dense"
                          label="Username"
                          // type="Multi-line"
                          value={this.state.username}
                          required
                          onChange={this.handleInputChange('username')}
                          error={!this.state.isUsernameValid}
                          onBlur={this.checkUsernameValidity}
                        />
                        {/* </div> */}
                        <FormHelperText
                          id="name-error-text"
                          className="Error_msg"
                        >
                          {!this.state.isUsernameValid
                            ? this.state.userNameRes
                            : ''}
                        </FormHelperText>
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        {/* <div className="usernamediv" xs={12} sm={4}> */}
                        <TextField
                          id="domainName"
                          name="domainName"
                          className="textfield"
                          margin="dense"
                          label="Domain Name"
                          value={this.state.domainName}
                          onChange={this.handleInputChange('domainName')}
                        />
                        {/* </div> */}
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        {/* <div className="usernamediv" xs={12} sm={4}> */}
                        <TextField
                          id="pageTitle"
                          name="pageTitle"
                          className="textfield"
                          margin="dense"
                          label="Page Title"
                          value={this.state.pageTitle}
                        />
                        {/* </div> */}
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        {/* <div className="usernamediv" xs={12} sm={4}> */}
                        <TextField
                          id="faviconLink"
                          name="faviconLink"
                          className="textfield"
                          margin="dense"
                          label="Favicon Link"
                          value={this.state.faviconLink}
                        />
                        {/* </div> */}
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormGroup className="form-input">
                        {/* <div className="usernamediv" xs={12} sm={4}> */}
                        <TextField
                          id="logo"
                          name="logo"
                          className="textfield"
                          margin="dense"
                          label="Logo"
                          value={this.state.logo}
                          onChange={this.handleInputChange('logo')}
                        />
                        {/* </div> */}
                      </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl className="selectbox">
                        <InputLabel htmlFor="selectLabel">
                          Select Billing Mode *
                        </InputLabel>

                        <Select
                          value={this.state.billingMode}
                          onChange={this.hanldeBillingModeChange}
                          name="billingMode"
                          // error={!this.state.isCltTypeValid}
                          // onBlur={this.checkCltTypeValidity}
                          input={<Input name="billingMode" />}
                        >
                          {BILLING_MODES.map(billingMode => (
                            <MenuItem
                              value={billingMode.value}
                              key={billingMode.value}
                            >
                              {billingMode.label}
                            </MenuItem>
                          ))}
                        </Select>
                        {/* <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isCltTypeValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText> */}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl className="selectbox">
                        <InputLabel htmlFor="selectLabel">
                          Select SalesPerson *
                        </InputLabel>

                        <Select
                          value={this.state.salesPerson}
                          onChange={this.handleSalesPersonChange}
                          name="salesPerson"
                          // error={!this.state.isCltTypeValid}
                          // onBlur={this.checkCltTypeValidity}
                          input={<Input name="salesPerson" />}
                        >
                          {this.state.allSalesPerson.map(billingMode => (
                            <MenuItem
                              value={billingMode.value}
                              key={billingMode.value}
                            >
                              {billingMode.label}
                            </MenuItem>
                          ))}
                        </Select>
                        {/* <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isCltTypeValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText> */}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl className="selectbox">
                        <InputLabel htmlFor="selectLabel">
                          Select Solution *
                        </InputLabel>

                        <Select
                          value={this.state.solution}
                          onChange={this.handleSolutionChange}
                          name="solution"
                          input={<Input name="solution" />}
                        >
                          {this.state.allSolution.map(solutions => (
                            <MenuItem
                              value={solutions.value}
                              key={solutions.value}
                            >
                              {solutions.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <FormGroup className="form-input">
                    <Grid justify="center" container>
                      <Button
                        color="default"
                        variant="outlined"
                        size="medium"
                        margin="normal"
                        className="btn"
                        onClick={this.handleCancelClick}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        size="medium"
                        margin="normal"
                        className="btn"
                        // onClick={this.handleSubmit}
                        onClick={this.handleSaveClick}
                        type="submit"
                        disabled={
                          !(
                            this.state.isEmailValid &&
                            this.state.isBusinessNameValid &&
                            this.state.email !== '' &&
                            this.state.businessname !== '' &&
                            this.state.contactp !== '' &&
                            this.state.isContactpValid &&
                            this.state.phoneno !== '' &&
                            this.state.isPhonenoValid &&
                            this.state.address !== '' &&
                            this.state.isAddressValid &&
                            this.state.city !== '' &&
                            this.state.isCityValid &&
                            this.state.state !== '' &&
                            this.state.country !== '' &&
                            this.state.username !== '' &&
                            this.state.isUsernameValid &&
                            this.state.clttype !== '' &&
                            this.state.pin !== '' &&
                            this.state.isPinValid &&
                            this.state.pan !== '' &&
                            this.state.isPanValid &&
                            this.state.billingMode !== '' &&
                            this.state.salesPerson !== '' &&
                            this.state.isUsernameAvailable === 'AVAILABLE'
                          )
                        }
                      >
                        Submit
                      </Button>
                    </Grid>
                  </FormGroup>
                </CardActions>
              </div>
            </Card>
          </Grid>
        </Grid>
      </div>
    )
  }
}
AddPartner.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withSharedSnackbar(withApollo(AddPartner))



// WEBPACK FOOTER //
// ./src/components/Modules/AddPartner/index.jsx